export default __webpack_public_path__ + "images/df17b1ea70138b0e11daadab5d56a347-nonprofitandngos.webp";